module.exports = __webpack_public_path__ + "img/science-logo.70dd7268.png";